(() => {
  const D = window.Dallas || {};
  const strings = D.strings || {};
  const FREE_FRANCE_FROM = 15000;

  const ZIPS = {
    FR: '57000',
    BE: '1000',
    DE: '10115',
    LU: '1148',
    NL: '1012',
    ES: '28001',
    GB: 'SW1A1AA',
    IT: '00118',
    PT: '1000-001',
    AT: '1010',
    DK: '1050',
    IE: 'D02AF30',
    CH: '8001',
    LT: '01100',
    NO: '0150',
    PL: '00-001',
    CZ: '11000',
    RO: '010011',
    SK: '81101',
    SI: '1000',
    BG: '1000',
    HR: '10000',
    EE: '10111',
    HU: '1011',
    LV: 'LV1010',
    FI: '00100',
    GR: '10552',
    SE: '11120',
    CY: '1010',
    MT: 'VLT1110',
    IS: '101',
    MC: '98000',
    MQ: '97200',
    GP: '97100',
    GF: '97300',
    RE: '97400',
    YT: '97600'
  };

  const GROUPS = {
    beNl: ['BE', 'DE', 'LU', 'NL'],
    south: ['ES', 'GB', 'UK', 'IT', 'PT', 'AT', 'DK', 'IE', 'AD', 'GI', 'GG'],
    east: ['LT', 'NO', 'PL', 'CZ', 'RO', 'SK', 'SI', 'BG', 'HR', 'EE', 'HU', 'LV'],
    nordic: ['FI', 'GR', 'SE'],
    islands: ['CY', 'MT'],
    swiss: ['CH', 'LI'],
    overseas: ['MQ', 'GP', 'GF', 'RE', 'YT', 'MF', 'BL', 'PM', 'PF', 'NC', 'WF']
  };

  const METHODS = {
    france: [
      { id: 'colissimo_domicile', name: 'Colissimo Domicile', days: '48h / 72h', cents: 790, colissimo: true },
      { id: 'colissimo_relay', name: 'Colissimo Relay', days: '48h / 72h', cents: 550, colissimo: true },
      { id: 'bureau_poste', name: 'Bureau de poste', days: '48h / 72h', cents: 550, colissimo: true },
      { id: 'chrono_domicile', name: 'Chrono Domicile', days: '24h / 48h', cents: 990 },
      { id: 'chrono_relais', name: 'Chrono relais', days: '24h / 48h', cents: 850 },
      { id: 'click_collect', name: 'Click & Collect', days: '24h / 48h', cents: 0 },
      { id: 'dhl_express', name: 'DHL Express', days: '24h / 48h', cents: 1500 }
    ],
    corsica: [
      { id: 'colissimo_domicile', name: 'Colissimo Domicile', days: '72h', cents: 790 },
      { id: 'colissimo_relay', name: 'Colissimo Relay', days: '72h', cents: 550 },
      { id: 'chrono_relais', name: 'Chrono relais', days: '72h', cents: 1390 },
      { id: 'chronopost', name: 'Chronopost', days: '48h', cents: 1900 }
    ],
    beNl: [
      { id: 'colissimo_domicile', name: 'Colissimo Domicile', days: '3-4 jours', cents: 995 },
      { id: 'colissimo_relay', name: 'Colissimo Relay', days: '3-4 jours', cents: 995 },
      { id: 'bureau_poste', name: 'Bureau de poste', days: '3-4 jours', cents: 995 },
      { id: 'dhl', name: 'DHL', days: '1-3 jours', cents: 1495 },
      { id: 'dhl_eco', name: 'DHL eco', days: '2-4 jours', cents: 1295 }
    ],
    south: [
      { id: 'colissimo_domicile', name: 'Colissimo Domicile', days: '3-6 jours', cents: 1195 },
      { id: 'dhl', name: 'DHL', days: '1-3 jours', cents: 1595 },
      { id: 'dhl_eco', name: 'DHL eco', days: '2-4 jours', cents: 1295 }
    ],
    swiss: [
      { id: 'colissimo_domicile', name: 'Colissimo Domicile', days: '2-3 jours', cents: 1490 },
      { id: 'dhl_eco', name: 'DHL eco', days: '2-4 jours', cents: 2295 }
    ],
    east: [
      { id: 'colissimo_domicile', name: 'Colissimo Domicile', days: '3-6 jours', cents: 1495 },
      { id: 'dhl', name: 'DHL', days: '24h / 72h', cents: 2295 },
      { id: 'dhl_eco', name: 'DHL eco', days: '48h / 96h', cents: 2295 }
    ],
    nordic: [
      { id: 'colissimo_domicile', name: 'Colissimo Domicile', days: '3-6 jours', cents: 1495 },
      { id: 'dhl', name: 'DHL', days: '24h / 72h', cents: 1595 },
      { id: 'dhl_eco', name: 'DHL eco', days: '48h / 96h', cents: 1495 }
    ],
    islands: [{ id: 'dhl', name: 'DHL', days: '24h / 72h', cents: 2095 }],
    iceland: [{ id: 'colissimo_domicile', name: 'Colissimo Domicile', days: '3-6 jours', cents: 1495 }],
    overseas: [
      { id: 'colissimo_domicile', name: 'Colissimo Domicile', days: '5-8 jours', cents: 1595 },
      { id: 'dhl', name: 'DHL', days: '3-6 jours', cents: 4495 }
    ]
  };

  const clone = (list) => list.map((item) => ({ ...item }));

  const money = (cents) => {
    const amount = (Number(cents) / 100).toLocaleString('fr-FR', {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2
    });
    return `${amount} €`;
  };

  const countryCode = (override) =>
    String((override || D.countryIso || 'FR') + '')
      .toUpperCase()
      .replace(/[^A-Z]/g, '')
      .slice(0, 2);

  const countryName = () => D.countryName || '';

  const isCorsica = (code, zip) => {
    if (countryCode(code) !== 'FR') return false;
    const value = String(zip || '').toUpperCase().replace(/\s/g, '');
    return /^20/.test(value) || /^2A/.test(value) || /^2B/.test(value);
  };

  const getMethods = (code, subtotalCents, zip) => {
    const iso = countryCode(code);
    const subtotal = Number(subtotalCents) || 0;
    let list = [];

    if (iso === 'FR' || iso === 'MC') {
      list = clone(isCorsica(iso, zip) ? METHODS.corsica : METHODS.france);
      if (!isCorsica(iso, zip) && subtotal >= FREE_FRANCE_FROM) {
        list = list.map((method) =>
          method.colissimo ? { ...method, cents: 0, free: true } : method
        );
      }
    } else if (GROUPS.beNl.includes(iso)) list = clone(METHODS.beNl);
    else if (GROUPS.south.includes(iso)) list = clone(METHODS.south);
    else if (GROUPS.swiss.includes(iso)) list = clone(METHODS.swiss);
    else if (GROUPS.east.includes(iso)) list = clone(METHODS.east);
    else if (GROUPS.nordic.includes(iso)) list = clone(METHODS.nordic);
    else if (GROUPS.islands.includes(iso)) list = clone(METHODS.islands);
    else if (iso === 'IS') list = clone(METHODS.iceland);
    else if (GROUPS.overseas.includes(iso)) list = clone(METHODS.overseas);

    return list.map((method) => ({
      ...method,
      free: method.cents === 0 || method.free === true
    }));
  };

  const cheapestPaid = (methods) => {
    const usable = methods.filter((method) => method.id !== 'click_collect');
    if (!usable.length) return null;
    return usable.reduce((best, method) => (method.cents < best.cents ? method : best));
  };

  const estimate = (subtotalCents, zip, code) => {
    const methods = getMethods(code, subtotalCents, zip);
    const best = cheapestPaid(methods);
    if (!best) return { cents: null, free: false, from: false };
    return {
      cents: best.cents,
      free: best.cents === 0,
      from: methods.filter((method) => method.id !== 'click_collect').length > 1 && best.cents > 0
    };
  };

  const formatShipping = (result, liveName) => {
    if (result.free) return strings.cartShippingFree || 'Offerte';
    if (result.cents == null) return strings.cartShippingAtCheckout || 'Calculé au paiement';
    const price = money(result.cents);
    if (liveName) return `${liveName} — ${price}`;
    if (result.from) {
      const prefix = strings.cartShippingFrom || 'À partir de';
      return `${prefix} ${price}`;
    }
    return price;
  };

  const parseRatePrice = (rate) => {
    if (!rate) return null;
    if (typeof rate.price === 'number') return Math.round(rate.price * 100);
    const parsed = parseFloat(String(rate.price).replace(',', '.'));
    if (Number.isNaN(parsed)) return null;
    return Math.round(parsed * 100);
  };

  const fetchLive = async (subtotalCents, zipOverride) => {
    const fallback = estimate(subtotalCents, zipOverride);
    const code = countryCode();
    const zip = zipOverride || ZIPS[code];
    if (!zip) return { ...fallback, live: false };

    const params = new URLSearchParams({
      'shipping_address[country]': code,
      'shipping_address[zip]': zip
    });

    try {
      const res = await fetch(`/cart/shipping_rates.json?${params.toString()}`, {
        headers: { Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' }
      });
      if (!res.ok) return { ...fallback, live: false };
      const data = await res.json();
      const rates = Array.isArray(data.shipping_rates) ? data.shipping_rates : [];
      if (!rates.length) return { ...fallback, live: false };

      let cheapest = null;
      rates.forEach((rate) => {
        const cents = parseRatePrice(rate);
        if (cents == null) return;
        if (!cheapest || cents < cheapest.cents) {
          cheapest = { cents, name: rate.name || '' };
        }
      });

      if (!cheapest) return { ...fallback, live: false };

      return {
        cents: cheapest.cents,
        free: cheapest.cents === 0,
        from: rates.length > 1,
        live: true,
        name: cheapest.name
      };
    } catch (err) {
      console.warn('Shipping rates lookup failed', err);
      return { ...fallback, live: false };
    }
  };

  const paint = (root, subtotalCents, result) => {
    if (!root) return;
    const priceEl =
      root.querySelector('[data-cart-shipping-price]') || root.querySelector('[data-cart-drawer-shipping]');
    const totalEl =
      root.querySelector('[data-cart-grand-total]') || root.querySelector('[data-cart-drawer-grand-total]');
    const labelEl = root.querySelector('[data-cart-drawer-shipping-label]');

    if (labelEl) {
      const name = countryName();
      const base = strings.cartShipping || 'Livraison';
      labelEl.textContent = name ? `${base} (${name})` : base;
    }

    if (priceEl) priceEl.textContent = formatShipping(result, result.live ? result.name : '');

    if (totalEl) {
      const shipping = result.cents == null ? 0 : result.cents;
      totalEl.textContent = money((Number(subtotalCents) || 0) + shipping);
    }
  };

  let fetchId = 0;

  const applyToPage = async (subtotalCents) => {
    const id = ++fetchId;
    const result = estimate(subtotalCents);
    document.querySelectorAll('[data-shipping-root]').forEach((root) => paint(root, subtotalCents, result));

    const live = await fetchLive(subtotalCents);
    if (id !== fetchId) return live;
    document.querySelectorAll('[data-shipping-root]').forEach((root) => paint(root, subtotalCents, live));
    return live;
  };

  window.DallasShipping = {
    money,
    estimate,
    fetchLive,
    formatShipping,
    applyToPage,
    countryCode,
    countryName,
    getMethods,
    isCorsica,
    cheapestPaid,
    defaultZip: (code) => ZIPS[countryCode(code)] || ''
  };

  document.addEventListener('DOMContentLoaded', () => {
    const root = document.querySelector('[data-shipping-root][data-shipping-subtotal]');
    if (!root) return;
    const subtotal = Number(root.getAttribute('data-shipping-subtotal'));
    if (Number.isNaN(subtotal) || subtotal <= 0) return;
    applyToPage(subtotal);
  });
})();
